// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppstoreTwoToneSvg from "@fishx/icons-svg/es/asn/AppstoreTwoTone";
import FishxIcon from '../components/FishxIcon';

var AppstoreTwoTone = function AppstoreTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreTwoToneSvg
  }));
};

AppstoreTwoTone.displayName = 'AppstoreTwoTone';
export default React.forwardRef(AppstoreTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AppstoreTwoTone.js
// module id = 2014
// module chunks = 0